<script lang="ts">
  import TrainingStatus from '../../TrainingStatus.svelte';
  import { calcTsRating } from '@/Util/utils';

  /** Training load to show the training status of. */
  export let load: number;
  export let title: string = '';
</script>

<!-- The stars are drawn at 106px wide and size themselves to their parent's height, so they are
     pinned to that and then shrunk to fit under a figure in a narrow card. -->
<div class="h-[9px] w-[58px] overflow-hidden" {title}>
  <div class="h-4 w-[106px]" style="transform: scale(0.55); transform-origin: top left;">
    <TrainingStatus
      trainingAdvice={{ training_status: { ts_rating: calcTsRating(load) } }}
      enableFade={false}
      showTooltip={false}
      showText={false}
      hideLeftLabel={true}
      showColour={false}
    />
  </div>
</div>
